<template>
  <div class="login">
    <div class="bg" v-loading="loading">
      <h1 v-if="validated">Account verification successful</h1>
      <div v-if="validated" class="btn" @click="login">Go login</div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Vue from 'vue'
  import { postAction } from '@/network/manage';

  export default {
    name: 'Verify',
    components: {

    },
    data() {
      return {
        loading:false,
        validated:false
      }
    },
    computed: {

    },
    created() {
      this.loading = true
      postAction('/sys/verify',{key:this.$route.query.key}).then((res) => {
        if(res.success){
          if(res.code == 201){
            this.$router.push('/login')
          }else{
            this.validated = true
          }
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.message);
      }).finally((res) => {
        this.loading = false
      });
    },
    methods: {
      login(){
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  .bg{position: fixed;top:0;left:0;width:100vw;height:100vh;display: flex;background:#F9F3EE;z-index:1;flex-direction: column;align-items: center;justify-content: center;}
  h1{color: #034844;font-size: 30px;margin-bottom:50px;}
  .btn{width: 300px;height:50px;border-radius: 4px;cursor: pointer;display: flex;align-items: center;justify-content: center;font-size: 20px;color:#ffffff;background-color: #8BB2B2;}
  @media (max-width: 768px) {

  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
  }
</style>
